module.exports = __webpack_public_path__ + "media/images/athletes/2202-fe4672b745ddc8a0c326573cc00b18cc.png";